// extracted by mini-css-extract-plugin
export var borderRadius = "_g0-4";
export var large = "_g0-3";
export var logoContainer = "_g0-0";
export var nameLogo = "_g0-2";
export var small = "_g0-1";